/**
 * 围棋规则引擎类型定义
 */
// 棋子颜色
export var StoneColor;
(function (StoneColor) {
    StoneColor[StoneColor["EMPTY"] = 0] = "EMPTY";
    StoneColor[StoneColor["BLACK"] = 1] = "BLACK";
    StoneColor[StoneColor["WHITE"] = 2] = "WHITE";
})(StoneColor || (StoneColor = {}));
// 棋步类型
export var MoveType;
(function (MoveType) {
    MoveType["NORMAL"] = "normal";
    MoveType["PASS"] = "pass";
    MoveType["RESIGN"] = "resign"; // 认输
})(MoveType || (MoveType = {}));
// 对局状态枚举
export var GameStatus;
(function (GameStatus) {
    GameStatus["WAITING"] = "waiting";
    GameStatus["PLAYING"] = "playing";
    GameStatus["PAUSED"] = "paused";
    GameStatus["FINISHED"] = "finished"; // 结束
})(GameStatus || (GameStatus = {}));
// 结果原因
export var GameResultReason;
(function (GameResultReason) {
    GameResultReason["RESIGN"] = "resign";
    GameResultReason["TIMEOUT"] = "timeout";
    GameResultReason["COUNTING"] = "counting";
    GameResultReason["CAPTURE"] = "capture";
    GameResultReason["FORFEIT"] = "forfeit";
    GameResultReason["DRAW"] = "draw"; // 和棋
})(GameResultReason || (GameResultReason = {}));
export var ProblemDifficulty;
(function (ProblemDifficulty) {
    ProblemDifficulty["EASY"] = "easy";
    ProblemDifficulty["MEDIUM"] = "medium";
    ProblemDifficulty["HARD"] = "hard";
    ProblemDifficulty["EXPERT"] = "expert";
})(ProblemDifficulty || (ProblemDifficulty = {}));
export var ProblemType;
(function (ProblemType) {
    ProblemType["LIFE_DEATH"] = "life_death";
    ProblemType["TESUJI"] = "tesuji";
    ProblemType["ENDGAME"] = "endgame";
    ProblemType["JOSEKI"] = "joseki"; // 定式
})(ProblemType || (ProblemType = {}));
//# sourceMappingURL=index.js.map